import { Comment, PaginatedResponse } from '@arpeggi/shared'
import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query'
import { getNextPage, getPreviousPage } from '../../../__legacy__/queries/common'
import { ApiService, GetCommentsParams } from '../../api'

export const useComments = ({
  discussionId,
  params,
  options
}: {
  discussionId: number
  params?: GetCommentsParams
  options?: UseInfiniteQueryOptions<PaginatedResponse<Comment>>
}) => {
  return useInfiniteQuery(
    ['discussions', discussionId, 'comments', params],
    ({ pageParam = params?.page || 1 }) =>
      ApiService.Comments.endpoints.getMany(discussionId, { ...params, page: pageParam }),
    {
      getPreviousPageParam: getPreviousPage,
      getNextPageParam: getNextPage,
      ...options
    }
  )
}
